function confirm(str, onTrue, onFalse, callbackOnClose = false) {
    ask(str, [
        {
            buttonClass: 'primary',
            title: 'Ja',
            callback: onTrue,
        },{
            buttonClass: 'secondary',
            title: 'Nee',
            callback: onFalse,
            onClose: callbackOnClose
        }
    ]);

}
async function asyncConfirm(str) {
    return new Promise((resolve) => {
        confirm(str, () => {
            resolve(true);
        }, () => {
            resolve(false);
        });
    });
}
function ask(str, options, size = 'tiny') {
    const $ = jQuery.noConflict();

    const optionsButtons = [];
    for(let i in options) {
        optionsButtons.push('<a href="#" class="button ' + (options[i].buttonClass === undefined ? 'primary' : options[i].buttonClass) + '" data-option-id="' + i + '">' + options[i].title + '</a>');
    }

    foundationPopup('<div class="question" style="text-align: center;">' + str + '<br /><br />' +
        optionsButtons.join('&nbsp;') +
        '</div>', function(elm, popup) {
        elm.find("a").click(function(e) {
            e.preventDefault();
            const a = $(this);
            const option = options[parseInt(a.attr('data-option-id'))];
            if (option && option.callback) {
                option.callback();
            }
            popup.close();
            return false;
        });
    }, size, () => {
        let closeCallback = null;
        options.forEach((option) => {
            if (option.onClose) {
                closeCallback = option.callback;
            }
        });
        if (closeCallback) {
            closeCallback();
        }
    });
}
function foundationPopup(html, onOpen, size, onClose) {
    var $ = jQuery.noConflict();
    var id = get_unique_id();
    size = size != undefined ? size : "large";

    $('body').append('<div id="'+id+'" class="'+size+' reveal" data-reveal data-close-on-click="false" data-multiple-opened="true" data-animation-in="slide-in-down fast ease-in" data-animation-out="slide-out-up fast ease-in">' +
        '<a class="close-reveal-modal" aria-label="Close" style="position: absolute; right: 25px;">&#215;</a>' +
        '<div class="popup"></div>' +
        '</div>');
    var elm = $('#'+id);
    if (typeof html === 'string') {
        elm.find('.popup').html("<br />"+html);
    } else {
        elm.find('.popup').html(html);
    }

    var popup = new Foundation.Reveal(elm);
    popup.open();

    elm.find('.close-reveal-modal').click(function() {
        popup.close();
        if (onClose) {
            onClose();
        }
        return false;
    }.bind(popup));

    setTimeout(function() {
        $('.reveal-overlay:not(:visible)').remove();
    },250);

    if(onOpen) {
        onOpen(elm,popup);
    }
}
